/**
 * Crypt Dice Color Schemes
 *
 * Color-specific schemes for the crypt dice design.
 * Each color defines the player-specific gradient stops for the main body.
 * The gold/bronze ornate frame colors are shared across all schemes.
 */

export interface CryptDiceColorScheme {
  /** Unique name used as gradient ID prefix to avoid SVG collisions */
  name: string;
  /** 5-stop linear gradient for the main body [stop0, stop24, stop47, stop75, stop100] */
  bodyGradient: [string, string, string, string, string];
}

export const CRYPT_DICE_COLOR_SCHEMES: Record<string, CryptDiceColorScheme> = {
  red: {
    name: 'red',
    bodyGradient: ['#ED1C24', '#C1272D', '#F7931E', '#ED1C24', '#F15A24']
  },
  yellow: {
    name: 'yellow',
    bodyGradient: ['#FBB03B', '#FCEE21', '#F15A24', '#FCEE21', '#F15A24']
  },
  blue: {
    name: 'blue',
    bodyGradient: ['#0071BC', '#0071BC', '#29ABE2', '#0071BC', '#29ABE2']
  },
  green: {
    name: 'green',
    bodyGradient: ['#007741', '#04AE58', '#046E40', '#06884C', '#046E40']
  }
};
